module.exports = __webpack_public_path__ + "img/ready.4380dfcc.svg";